import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { checkPromoCodeValidity } from '@app/actions/subscribeActions';
import PromoRedemptionForm from './components/PromoRedemptionForm';
import PromoRedemptionInfo from './components/PromoRedemptionInfo';
import { PackageBase } from '../Package/PackageStyledComponents';

const PromoRedemption = ({ checkPromoCodeValidity, showDiscount }) => (
  <PackageBase hasMargin>
    <section>
      <Title>
        <FormattedMessage id="promotion.title" />
      </Title>
      <SubTitle>
        <FormattedMessage id="promotion.subTitle" />
      </SubTitle>
    </section>
    {
      showDiscount
        ? <PromoRedemptionInfo />
        : <PromoRedemptionForm onSubmit={checkPromoCodeValidity} />
    }
  </PackageBase>
);

PromoRedemption.propTypes = {
  checkPromoCodeValidity: PropTypes.func.isRequired,
  showDiscount: PropTypes.bool,
};

PromoRedemption.defaultProps = {
  showDiscount: false,
};

export default withRouter(connect(null, { checkPromoCodeValidity })(PromoRedemption));

const Title = styled.p`
  margin: 0;
  font-size: 20px;
  text-align: left;
`;

const SubTitle = styled.p`
  margin: 5px 0;
  font-size: 30px;
  text-align: left;
  text-transform: uppercase;
`;
